import { MantineProvider } from '@mantine/core'
import { Notifications } from '@mantine/notifications'
import { ModalsProvider } from '@mantine/modals'

import { DefaultTheme } from 'src/theme/theme'
import { useAppState } from "src/state"
import { Loader } from "src/components/global/Loader"
import { NavigationWrapper } from "src/components/navigation/NavigationWrapper"
import { CourierInitializer } from 'src/components/global/CourierInitializer'

function App() {

    const { loading } = useAppState(state => state)

    return (
        <MantineProvider
            theme={DefaultTheme}
            defaultColorScheme='light'
        >
            <CourierInitializer />
            {loading ? (
                <Loader />
            ) : (
                <>
                    <Notifications position="top-right" />
                    <ModalsProvider>
                        <NavigationWrapper />
                    </ModalsProvider>
                </>
            )}
        </MantineProvider>
    )
}

export default App
